import * as Yup from "yup";

export const SITSettingsSchema = Yup.object({
  brackets: Yup.array()
    .of(
      Yup.object({
        tax_rate: Yup.string(),
        flat_amount: Yup.string(),
      }).test(
        "at-least-one",
        "At least one of Tax Rate or Fixed Charge is required",
        (value) => Boolean(value?.tax_rate || value?.flat_amount)
      )
    )
    .min(1, "Add at least one tax bracket."),
});
